import Box from '@mui/material/Box';

function MovingMrLaterImage() {
    return (
      <Box sx={{
        width: {xs: '100px', lg: 'auto' },
        height: '100%',
        position: { xs: 'static', lg: 'absolute' },
        top: '0',
        left: '100%',
        overflow: 'unset',
        transition: 'transform 0.5s ease-in-out',
        transform: { xs: 'translateY(0) rotate(0)', lg: 'translateY(20px) rotate(360deg)' },
        }}>
        <img
          src="static/images/mrlater.png"
          alt="Mr. Later"
          style={{
            width: 'inherit',
            height: 'inherit',
          }}
        />
      </Box>
    );
  }

  export { MovingMrLaterImage };